import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Row, Tag } from "antd";
import { EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
function FormFieldTemplateVersion() {
    const { t } = useTranslation();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: TemplateMetaDataField.Version,
                hidden: true,
                children: /*#__PURE__*/ _jsx("input", {
                    type: "hidden"
                })
            }),
            /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
                fieldNames: TemplateMetaDataField.Version,
                permissionCheck: {
                    whenRole: EUserRole.Translator,
                    roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
                },
                children: /*#__PURE__*/ _jsx(Form.Item, {
                    label: getFieldNameTranslated(TemplateMetaDataField.Version, t),
                    shouldUpdate: (prev, next)=>prev.version !== next.version,
                    children: ({ getFieldValue })=>{
                        const version = getFieldValue([
                            TemplateMetaDataField.Version
                        ]);
                        return /*#__PURE__*/ _jsx(_Fragment, {
                            children: /*#__PURE__*/ _jsx(Row, {
                                children: /*#__PURE__*/ _jsx(Tag, {
                                    style: {
                                        minWidth: "5rem",
                                        textAlign: "center"
                                    },
                                    color: version ? "blue" : "yellow",
                                    children: version ? version : t("Initial (1)")
                                })
                            })
                        });
                    }
                })
            })
        ]
    });
}
export { FormFieldTemplateVersion };
